var map = {
	"./calendar.svg": 1490,
	"./calendar_add_on.svg": 5594,
	"./calendar_grey.svg": 2132,
	"./call_green.svg": 5396,
	"./cancel.svg": 7366,
	"./case_add_btn.svg": 1517,
	"./check_blue.svg": 6919,
	"./check_white.svg": 7186,
	"./left_arrow.svg": 389,
	"./next_time.svg": 7561,
	"./profile_picture.svg": 5300,
	"./profile_picture1.svg": 5501,
	"./report_add.svg": 7414,
	"./right_arrow.svg": 436,
	"./summary_add_btn.svg": 7817,
	"./time.svg": 5619,
	"./video_camera.svg": 5633,
	"./video_green.svg": 5069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6844;